module.exports = __webpack_public_path__ + "static/media/volleyball-ball.8d3125ba.svg";